import React from 'react';
import Config from "../../config/Config";
import Interview from './tool/interview';
import Application from './tool/application';
import Call from './tool/call';
import Favor from './tool/favor';

let path = Config.getBasePath();

class applicant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabPaneData: [
        { label: "面试通知", value: "1" },
        { label: "报名记录", value: "2" },
        { label: "电话联系", value: "3" },
        { label: "收藏记录", value: "4" },
      ],
      tabValue: this.props.location.state ? this.props.location.state?.tab : "1"
    };
  }

  componentDidMount() {

  }


  componentDidUpdate(nextProps) {
    if (nextProps?.location?.state && this.props?.location?.state) {
      if (JSON.stringify(nextProps.location.state) != JSON.stringify(this.props.location.state)) {
        this.setState({ tabValue: this.props.location.state.tab })
      }
    }
  }



  onTab = (data) => {
    this.setState({ tabValue: data?.value });
  }

  render() {
    const { tabPaneData, tabValue } = this.state;

    return (
      <div component-data="applicant">
        <div className='box_1440 page'>
          <div style={{display:'flex'}}>
            <div className='tabPane_Box'>
              {tabPaneData.map((item) => (
                <div
                  onClick={() => this.onTab(item)}
                  className={tabValue === item.value ? 'tab_item_check' : 'tab_item'}
                >
                  {item?.label}
                </div>
              ))}
            </div>
            <div className='sg-tables'>
              {tabValue === '1' && <Interview />}
              {tabValue === '2' && <Application />}
              {tabValue === '3' && <Call />}
              {tabValue === '4' && <Favor />}
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default applicant;